<template>
    <v-form>
        <!--
        //TODO: add your subtitle here
        <div class="reset-password__title">
            {{loginConstants.PASSWORD_RESET_TITLE}}
        </div>-->
        <v-text-field
                name="Recovery Code"
                data-qe-id="login_recovery-code_input"
                :label="loginConstants.VERIFICATION_CODE_LABEL"
                v-model="recoveryCode"
                :disabled="isSubmitting"
                required
                v-on:keydown.enter.prevent
        >
        </v-text-field>
        <login-error></login-error>
        <v-card-actions>
            <v-layout row pt-3>
                <v-btn
                        id="submit_returned_recovery_code"
                        data-qe-id="submit_returned_recovery_code"
                        color="ypo_blue"
                        @click="submit"
                        :disabled="!recoveryCode || isSubmitting"
                        large
                        block
                >
                    {{loginConstants.SUBMIT}}
                </v-btn>
            </v-layout>
        </v-card-actions>
    </v-form>
</template>
<script>
    import { mapActions } from 'vuex';
    import { storeAction } from "../../../store/storeActions.constant";
    import { loginConstants } from "../login.constants";
    import LoginError from "../LoginError";

    export default {
        name: 'RecoveryCodeForm',
        components: { LoginError },
        data: () => ({
            loginConstants,
            recoveryCode: null,
        }),
        props: {
            changeCardState: Function,
            toggleProgressIndicator: Function,
            isSubmitting: Boolean,
            returnToLogin: Function,
        },
        computed: {},
        methods: {
            ...mapActions({
                submitRecoveryToken: `auth/${storeAction.submitRecoveryToken}`,
            }),
            submit() {
                this.toggleProgressIndicator();
                this.submitRecoveryToken(this.recoveryToken);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';

    .reset-password__title {
        padding: 5px 10px 20px;
        text-align: center;
        font-size: 16px;
        color: $ypo-blue;
    }
    #submit_returned_recovery_code {
        .v-btn__content {
            color: $white;
        }
    }
</style>
